import React from 'react';

import CoreRankingPage from '@ts-core/modules/rankings/pages/RankingsPage';

import useRankingsPageTabs from './useRankingPageTabs';

const RankingsPage = () => {
  const tabsProps = useRankingsPageTabs();
  return <CoreRankingPage tabsProps={tabsProps} />;
};

export default RankingsPage;
